<template>
	<div class="top-menu">
		     <div class="container">
		     	<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 235 50">
  <image id="矢量智能对象" x="-4" y="5" xlink:href="data:img/png;base64,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"/>
</svg>

		     	<!-- <img :src="logo"/> -->
		     	<p>{{title}}</p>
		     	<p style="font-size:14px;float:right;color:#fff">
		     		<el-button type="danger" plain @click="goto()">天猫旗舰店</el-button>
		     	</p>
		     </div>
	  </div>
</template>

<script>
	export default{
		name:'top-menu',
		components:{},
		data(){
			return{
				txt:'nihao',
				logo:'',
				title:'',
			}
		},
		methods:{
			getInfo(){
				this.axios({
					method: 'get',
					url: this.GLOBAL.getInfoApi,
					data: {}
				})
				.then((res) => {
					this.logo = res.data.data.logo;
					this.title = res.data.data.title;
				})
				.catch((err) => {
					console.log(err)
				})
			},
			goto(){
				window.location.href = "https://tiantujj.tmall.com";
			}
		},
		created(){
			this.getInfo();
		}
	}
</script>

<style lang="less">
.cls-1,.cls-2{fill:#fff;}
.cls-1{fill-rule:evenodd;}
.cls-2{font-size:8.77px;font-family:STHeitiSC-Light, Heiti SC;}
svg{
	width:234px;
	line-height:80px;
}
.top-menu{
	height: 80px;
	background: #229dfe;
	line-height: 80px;
	img{
		margin-bottom:10px;
		width:235px;
		height:50px;
	}
	p{
		display: inline-block;
		color: #fff;
		font-size: 35px;
		margin-left:80px;
		font-family:"SimHei";
	}
}
.el-button--danger.is-plain{
	color:#fd0033;
}
.el-button--danger.is-plain:active{
	background: #fd0033;
	border: #fd0033;
}

.el-button--danger.is-plain:focus, .el-button--danger.is-plain:hover{
	background: #fd0033;
	border: #fd0033;
}
</style>


// WEBPACK FOOTER //
// src/components/common/Head.vue